import React, { useContext, useState } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../../common/types';
import { Box, Grid, Button, TextField, FormHelperText, GridList, isWidthUp, LinearProgress } from '@material-ui/core';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import IndexedDb from '../IndexedDb';
import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { Chart as ChartJS, LinearScale, CategoryScale, BarElement, PointElement, LineElement, Legend, Tooltip, LineController, BarController } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation'
import Observationdata from '../../../../src/data/Observationdata.json';
import moment from 'moment'
import { jsPDF } from 'jspdf'
import api from '../../../store/api';
import ObservationChart from './ObservationChart';
import "./ObservationChartPrint.css";
import { useDispatch } from 'react-redux';
import { setpcrstate } from '../../../store/modules/PcrSlice';
import { useSelector } from "react-redux";
import { pcrstate } from "../../../store/modules/PcrSlice";
import html2canvas from 'html2canvas';

// interface PcrWidgetProps extends IAppPropsWithRoute { };
ChartJS.register(LinearScale, CategoryScale, BarElement, PointElement, LineElement, Legend, Tooltip, LineController, BarController, annotationPlugin);

export interface PcrWidgetProps extends IAppPropsWithRoute {
    pcrId:any
    setTriggerAPI:any
};
interface chartob {
    resipratoryRate: number
}
interface Files {
    Key: string;
    img: any;
    Title: string;
}


    const PCRObservationChartPDF: React.FC<PcrWidgetProps> = (props) => {
    const classes = useStyles();
    const {pcrId,setTriggerAPI} = props;
    const [uname, setname] = useState(" ");
    const [names, setNames] = useState([]);
    const [fr, setfr] = useState([]);
    const [Sat, setSat] = useState([]);
    const [Observationtime, setObservationtime] = useState([]);
    const [Observationtimechart, setObservationtimechart] = useState([]);
    const [ResprateRedUpper, setResprateRedUpper] = useState<number>();
    const [ResprateYellowUpper, setResprateYellowUpper] = useState<number>();
    const [ResprateRedLower, setResprateRedLower] = useState<number>();
    const [ResprateYellowLower, setResprateYellowLower] = useState<number>();
    const [ResprateMax, setResprateMax] = useState<number>();
    const [FlowrateMax, setFlowrateMax] = useState<number>();
    const [SatMax, setSatMax] = useState<number>();
    const [BpMax, setBpMax] = useState<number>();
    const [BpdiaMax, setBpdiaMax] = useState<number>();
    const [HeartrateMax, setHeartrateMax] = useState<number>();
    const [TempMax, setTempMax] = useState<number>();
    const [ResprateMin, setResprateMin] = useState<number>();
    const [FlowrateMin, setFlowrateMin] = useState<number>();
    const [SatMin, setSatMin] = useState<number>();
    const [BpMin, setBpMin] = useState<number>();
    const [BpdiaMin, setBpdiaMin] = useState<number>();
    const [HeartrateMin, setHeartrateMin] = useState<number>();
    const [TempMin, setTempMin] = useState<number>();
    const [OSatRedUpper, setOSatRedUpper] = useState<number>();
    const [OSatYellowUpper, setOSatYellowUpper] = useState<number>();
    const [OSatRedLower, setOSatRedLower] = useState<number>();
    const [OSatYellowLower, setOSatYellowLower] = useState<number>();
    const [OFRedUpper, setOFRRedUpper] = useState<number>();
    const [OFRYellowUpper, setOFRYellowUpper] = useState<number>();
    const [OFRRedLower, setOFRRedLower] = useState<number>();
    const [OFRYellowLower, setOFRYellowLower] = useState<number>();
    const [BPRedUpper, setBPRedUpper] = useState<number>();
    const [BPYellowUpper, setBPYellowUpper] = useState<number>();
    const [BPRedLower, setBPRedLower] = useState<number>();
    const [BPYellowLower, setBPYellowLower] = useState<number>();
    const [BPdiaRedUpper, setBPdiaRedUpper] = useState<number>();
    const [BPdiaYellowUpper, setBPdiaYellowUpper] = useState<number>();
    const [BPdiaRedLower, setBPdiaRedLower] = useState<number>();
    const [BPdiaYellowLower, setBPdiaYellowLower] = useState<number>();
    const [HRRedUpper, setHRRedUpper] = useState<number>();
    const [HRYellowUpper, setHRYellowUpper] = useState<number>();
    const [HRRedLower, setHRRedLower] = useState<number>();
    const [HRYellowLower, setHRYellowLower] = useState<number>();
    const [TEMPRedUpper, setTEMPRedUpper] = useState<number>();
    const [TEMPYellowUpper, setTEMPYellowUpper] = useState<number>();
    const [TEMPRedLower, setTEMPRedLower] = useState<number>();
    const [TEMPYellowLower, setTEMPYellowLower] = useState<number>();
    const [bpsys, setbpsys] = useState([]);
    const [bpdia, setbpdia] = useState([]);
    const [heartrate, setheartrate] = useState([]);
    const [temp, settemp] = useState([]);
    const [conc, setconc] = useState([]);
    const [bloodsugar, setbloodsugar] = useState([]);
    const [PainScore, setPainScore] = useState([]);
    const [ResprateSteps, setResprateSteps] = useState<number>();
    const [FlowrateSteps, setFlowrateSteps] = useState<number>();
    const [SatSteps, setSatSteps] = useState<number>();
    const [BpSteps, setBpSteps] = useState<number>();
    const [BpdiaSteps, setBpdiaSteps] = useState<number>();
    const [HeartrateSteps, setHeartrateSteps] = useState<number>();
    const [TempSteps, setTempSteps] = useState<number>();
    const [newborn, setnewborn] = useState(0);
    const [diastolic, setdiastolic] = useState(0);
    const formData = new FormData();
    const htmlRef = React.useRef<HTMLDivElement>(null);
    const numDatapoints = 15;
    const colWidthInPixels = 60;
    let resObservationsFields: any = [];
    let resBackgroundObservationsFields: any = [];
    let isBackgroundObstetric: any = false;
    let dob: any = "";
    let fileName: string = "";

    React.useEffect(() => {
        getObservationData();
    }, []);

    const getObservationData = async () => {
        try {

            const res = await api.GetObservationData('pcrId=' + pcrId, null);
            if (res.errorRaised === false) {
                resObservationsFields = res?.result?.pcrObservationChartData;
                resBackgroundObservationsFields= res?.result?.pcrBckgroundChartData;
                isBackgroundObstetric= res?.result?.isBackgroundObstetric
                dob = res?.result?.dob;
                if (resObservationsFields.length > 0) {
                    setname(resObservationsFields[0].patientWeight)
                }
                fileName = res?.result?.fileName;
                handleChartData();
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    const handleChartData = async () => {

        let result = Observationdata;

        if (result != null) {
            var Maternity = null;
            let val: string = "";
            let vBirthDate = "";
            let Obstetric = 0;
            let Background = null;
            var Obsetric = null;
          
            // Background = resBackgroundObservationsFields;
            Obsetric = isBackgroundObstetric === false ? 0 : 1;
            val = dob;
            if (val && val != null) {
                vBirthDate = val;

                var resbd = new Date(vBirthDate);
                const [day, month, year] = format(resbd, 'dd/MM/yyyy').split('/');
                var today = new Date();
                var dt = year + "-" + month + "-" + day;
                var bday = new Date(moment(dt).toDate());
                const age = today.getFullYear() - bday.getFullYear();
                const m = today.getMonth() - bday.getMonth();
                const d = today.getDate() - bday.getDate();
                if (d <= 0 && m <= 0 && age <= 0 && Obstetric !== 1) {
                    Maternity = Observationdata.Newborn;
                    setnewborn(1);
                }
                else if (m < 3 && age <= 0 && Obstetric !== 1) {
                    Maternity = Observationdata['1+ days'];
                }
                else if (m >= 3 && age <= 0 && Obstetric !== 1) {
                    Maternity = Observationdata['3+ months'];
                }
                else if (age >= 1 && age < 5 && Obstetric !== 1) {
                    Maternity = Observationdata['1+ years'];
                }
                else if (age >= 5 && age < 12 && Obstetric !== 1) {
                    Maternity = Observationdata['5+ years'];
                }
                else if (age >= 12 && age < 18 && Obstetric !== 1) {
                    Maternity = Observationdata['12+ years'];
                }
                else if (Obstetric === 1) {
                    Maternity = Observationdata.Maternity;
                    Obsetric = 1;
                }
                else {
                    Maternity = Observationdata['18+ years'];
                }
                for (let i = 0; i < Maternity.length; i++) {
                    let upperred = Maternity[i].btf_ranges?.upper?.red_if_above;
                    let upperyellow = Maternity[i].btf_ranges?.upper?.yellow_if_above;
                    let lowerred = Maternity[i].btf_ranges?.lower?.red_if_below;
                    let loweryellow = Maternity[i].btf_ranges?.lower?.yellow_if_below;
                    if (Maternity[i].observation === "Respiratory Rate") {
                        setResprateRedUpper(upperred);
                        setResprateYellowUpper(upperyellow);
                        setResprateRedLower(lowerred);
                        setResprateYellowLower(loweryellow);
                        setResprateMax(Number(Maternity[i].high_value));
                        setResprateMin(Number(Maternity[i].low_value));
                        setResprateSteps(Number(Maternity[i].step));
                    }
                    if (Maternity[i].observation === "O₂ Saturation") {
                        let upperred = Maternity[i].btf_ranges?.upper?.red_if_above;
                        let upperyellow = Maternity[i].btf_ranges?.upper?.yellow_if_above;
                        let lowerred = Maternity[i].btf_ranges?.lower?.red_if_below;
                        let loweryellow = Maternity[i].btf_ranges?.lower?.yellow_if_below;
                        setOSatRedUpper(upperred ?? 0);
                        setOSatYellowUpper(upperyellow);
                        setOSatRedLower(lowerred ?? 0);
                        setOSatYellowLower(loweryellow);
                        setSatMax(Number(Maternity[i].high_value));
                        setSatMin(Number(Maternity[i].low_value));
                        setSatSteps(Number(Maternity[i].step));
                    }
                    if (Maternity[i].observation === "O₂ Flow Rate") {
                        let upperred = Maternity[i].btf_ranges?.upper?.red_if_above;
                        let upperyellow = Maternity[i].btf_ranges?.upper?.yellow_if_above;
                        let lowerred = Maternity[i].btf_ranges?.lower?.red_if_below;
                        let loweryellow = Maternity[i].btf_ranges?.lower?.yellow_if_below;
                        setOFRRedUpper(upperred);
                        setOFRYellowUpper(upperyellow);
                        setOFRRedLower(lowerred);
                        setOFRYellowLower(loweryellow);
                        setFlowrateMax(Number(Maternity[i].high_value));
                        setFlowrateMin(Number(Maternity[i].low_value));
                        setFlowrateSteps(Number(Maternity[i].step));
                    }
                    if (Maternity[i].observation === "Systolic Blood Pressure" || Maternity[i].observation === "Blood Pressure") {
                        let upperred = Maternity[i].btf_ranges?.upper?.red_if_above;
                        let upperyellow = Maternity[i].btf_ranges?.upper?.yellow_if_above;
                        let lowerred = Maternity[i].btf_ranges?.lower?.red_if_below;
                        let loweryellow = Maternity[i].btf_ranges?.lower?.yellow_if_below;
                        setBPRedUpper(upperred);
                        setBPYellowUpper(upperyellow);
                        setBPRedLower(lowerred);
                        setBPYellowLower(loweryellow);
                        setBpMax(Number(Maternity[i].high_value !== undefined ? Maternity[i].high_value : 120));
                        setBpMin(Number(Maternity[i].low_value !== undefined ? Maternity[i].low_value : 0));
                        setBpSteps(Number(Maternity[i].step !== undefined ? Maternity[i].step : 20));
                    }
                    if (Maternity[i].observation === "Diastolic Blood Pressure") {
                        let upperred = Maternity[i].btf_ranges?.upper?.red_if_above;
                        let upperyellow = Maternity[i].btf_ranges?.upper?.yellow_if_above;
                        let lowerred = Maternity[i].btf_ranges?.lower?.red_if_below;
                        let loweryellow = Maternity[i].btf_ranges?.lower?.yellow_if_below;
                        setBPdiaRedUpper(upperred);
                        setBPdiaYellowUpper(upperyellow);
                        setBPdiaRedLower(lowerred);
                        setBPdiaYellowLower(loweryellow);
                        setBpdiaMax(Number(Maternity[i].high_value));
                        setBpdiaMin(Number(Maternity[i].low_value));
                        setBpdiaSteps(Number(Maternity[i].step));
                        setdiastolic(1);
                        localStorage.setItem("Diastolic", "1");
                    }
                    if (Maternity[i].observation === "Heart Rate" || Maternity[i].observation === "Heart Rate (Apical)") {
                        let upperred = Maternity[i].btf_ranges?.upper?.red_if_above;
                        let upperyellow = Maternity[i].btf_ranges?.upper?.yellow_if_above;
                        let lowerred = Maternity[i].btf_ranges?.lower?.red_if_below;
                        let loweryellow = Maternity[i].btf_ranges?.lower?.yellow_if_below;
                        setHRRedUpper(upperred);
                        setHRYellowUpper(upperyellow);
                        setHRRedLower(lowerred);
                        setHRYellowLower(loweryellow);
                        setHeartrateMax(Number(Maternity[i].high_value));
                        setHeartrateMin(Number(Maternity[i].low_value));
                        setHeartrateSteps(Number(Maternity[i].step));
                    }
                    if (Maternity[i].observation === "Temperature") {
                        let upperred = Maternity[i].btf_ranges?.upper?.red_if_above;
                        let upperyellow = Maternity[i].btf_ranges?.upper?.yellow_if_above;
                        let lowerred = Maternity[i].btf_ranges?.lower?.red_if_below;
                        let loweryellow = Maternity[i].btf_ranges?.lower?.yellow_if_below;
                        setTEMPRedUpper(upperred);
                        setTEMPYellowUpper(upperyellow);
                        setTEMPRedLower(lowerred);
                        setTEMPYellowLower(loweryellow);
                        setTempMax(Number(Maternity[i].high_value));
                        setTempMin(Number(Maternity[i].low_value));
                        setTempSteps(Number(Maternity[i].step));
                    }

                }

            }

            // if (Background != null) {
                // for (let i = 0; i < Background.length; i++) {
                //     setResprateRedUpper(Background[i].r1ResprateRedUpper);
                //     setResprateYellowUpper(Background[i].r2ResprateYellowUpper);
                //     setResprateYellowLower(Background[i].r5ResprateYellowLower);
                //     setResprateRedLower(Background[i].r6ResprateRedLower);
                //     setOSatRedUpper(Background[i].s1OSatRedUpper);
                //     setOSatYellowUpper(Background[i].s2OSatYellowUpper);
                //     setOSatYellowLower(Background[i].s5OSatYellowLower);
                //     setOSatRedLower(Background[i].s6OSatRedLower);
                //     setOFRRedUpper(Background[i].f1OFRedUpper);
                //     setOFRYellowUpper(Background[i].f2OFRYellowUpper);
                //     setOFRYellowLower(Background[i].f5OFRYellowLower);
                //     setOFRRedLower(Background[i].f6OFRRedLower);
                //     setBPRedUpper(Background[i].bP1BPRedUpper);
                //     setBPYellowUpper(Background[i].bP2BPYellowUpper);
                //     setBPYellowLower(Background[i].bP5BPYellowLower);
                //     setBPRedLower(Background[i].bP6BPRedLower);
                //     setHRRedUpper(Background[i].hR1HRRedUpper);
                //     setHRYellowUpper(Background[i].hR2HRYellowUpper);
                //     setHRYellowLower(Background[i].hR5HRYellowLower);
                //     setHRRedLower(Background[i].hR6HRRedLower);
                //     setTEMPRedUpper(Background[i].t1TEMPRedUpper);
                //     setTEMPYellowUpper(Background[i].t2TEMPYellowUpper);
                //     setTEMPYellowLower(Background[i].t5TEMPYellowLower);
                //     setTEMPRedLower(Background[i].t6TEMPRedLower);
                   
                // }
            // }
        }

        if (resObservationsFields.length > 0) {

            resObservationsFields = resObservationsFields.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime())

            let resarr: any = [];
            //flowrate      
            for (let i = 0; i < resObservationsFields.length; i++) {
                resarr.push((format(new Date(resObservationsFields[i].date), "HH:mm")));
            }
            setObservationtime(resarr);
            resarr = []
            for (let i = 0; i < resObservationsFields.length; i++) {
                resarr.push((format(new Date(resObservationsFields[i].date), "HH:mm")));
            }
            let x = 15;
            if (resarr.length > 0 && resarr.length < 15) {
                x = 15 - resarr.length;
            }
            for (let i = 0; i < x; i++) {
                resarr.push("")
            }
            setObservationtimechart(resarr);
            resarr = []
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].resipratoryRate) {
                    resarr.push({
                        col: i,
                        value: parseInt(resObservationsFields[i].resipratoryRate),
                    });
                }
            }
            setNames(resarr);
            resarr = []
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].spO2) {
                    resarr.push({
                        col: i,
                        value: parseInt(resObservationsFields[i].spO2),
                    });
                }
            }
            setSat(resarr)
            resarr = [];
            //flowrate
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].o2FlowRate) {
                    resarr.push({
                        col: i,
                        value: parseInt(resObservationsFields[i].o2FlowRate),
                    });
                }
            }
            setfr(resarr);
            resarr = [];
            //Systolic bp
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].bpSys) {
                    resarr.push({
                        col: i,
                        value: parseInt(resObservationsFields[i].bpSys),
                    });
                }
            }
            setbpsys(resarr);
            resarr = [];
            //Diastolic bp
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].bpdIa) {
                    resarr.push({
                        col: i,
                        value: parseInt(resObservationsFields[i].bpdIa),
                    });
                }

            }
            setbpdia(resarr);
            resarr = [];
            //heartrate
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].heartRate) {
                    resarr.push({
                        col: i,
                        value: parseInt(resObservationsFields[i].heartRate),
                    });
                }

            }
            setheartrate(resarr);
            resarr = [];
            //Temperature
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].temperature) {
                    resarr.push({
                        col: i,
                        value: parseInt(resObservationsFields[i].temperature),
                    });
                }
            }
            settemp(resarr);
            resarr = [];
            //consciousness
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].consciousness) {
                    if (resObservationsFields[i].consciousness)
                        resarr.push({
                            col: i,
                            value: (resObservationsFields[i].consciousness),
                        });
                }
            }
            setconc(resarr);
            resarr = [];
            //Blood Suger
            for (let i = 0; i < resObservationsFields.length; i++) {
                resarr.push(parseFloat(resObservationsFields[i].bgl));
            }
            setbloodsugar(resarr);
            resarr = [];
            //Pain Score
            for (let i = 0; i < resObservationsFields.length; i++) {
                if (resObservationsFields[i].painScore) {
                    resarr.push({
                        col: i,
                        value: parseInt(resObservationsFields[i].painScore),
                    });
                }
            }
            setPainScore(resarr)
        }
        savepdfblob();
    }

    const savepdfblob = async () => {
        const div = window.document.getElementsByClassName("printChartSection")[0] as HTMLElement;
        div.style.display = "block";
        const divHeight = div.clientHeight;
        const divWidth = div.clientWidth;
        if (!htmlRef.current) {
            return;
        }
        const dataURLPattern = /^data:image\/\w+;base64,/;
        html2canvas(div).then((canvas) => {
            div.style.display = "none";
            const imgData = canvas.toDataURL('image/png');
            if (!dataURLPattern.test(imgData)) {
                // Data URL has the expected format
                return;
            }
            const doc = new jsPDF('p', 'px', [divWidth, divHeight]);
            const pdfWidth = doc.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight, '', 'FAST');
            // create blob
            var blobpdf = new Blob([doc.output('blob')], { type: 'application/pdf' });

            let updatedFileName;
            if (fileName !== null && fileName !== undefined) {
                updatedFileName = fileName;
            }
            else {
                updatedFileName = generateRandomGuid() + "_PCRPDF.pdf";
            }
            const updatedFile = new File([blobpdf], updatedFileName, {
                type: 'application/pdf',
            });
            formData.append('file', updatedFile);
            SaveFileToBlobStorage(formData);
            setTriggerAPI(true);
            //  // Open the PDF in a new tab
            // const pdfURL = URL.createObjectURL(blobpdf);
            // window.open(pdfURL, '_blank');

            // Close the current tab
            // window.close();
        }).catch((error) => {
            console.log('Error creating PDF:' + (error));
            alert('Error creating PDF:' + (error))
            return false;
        });
    }

    const SaveFileToBlobStorage = async (formData: any) => {
        const resu = await api.pushFileToBlobStorage("", formData);
        if (resu?.error) {
            alert("Error Occurs while Uploading")
        }
    }

    const generateRandomGuid = () => {
        const newGuid = uuidv4();
        return newGuid;
    };

    const getmaxsttepresp = (max: any | undefined, steps: any | undefined, min: any | undefined) => {
        if (max !== undefined && steps !== undefined) {
            if (min === 15) {
                var Modval = (Number(max) + Number(steps));
                var res = (Number(max));
                return res
            }
            else {
                var Modval = (Number(max) + Number(steps));
                var res = (Number(Modval) - 5);
                return res
            }

        }
    }

    const getmaxstepsBp = (max: any | undefined, steps: any | undefined) => {
        if (max !== undefined && steps !== undefined) {
            if (Number(max) === 155) {
                return (Number(max) + 10)
            }
            if (Number(max) === 135) {
                return (Number(max) + 10)
            }
            else {
                return max;
            }
        }
    }

    const getmaxsttepsInRange = (max: any | undefined, steps: any | undefined) => {
        if (max !== undefined && steps !== undefined) {
            var Modval = (Number(max) % Number(steps));
            if (Number(Modval) > 0) {
                var res = (Number(Modval) + Number(max));
                return res
            }
            else {
                var res = (10 + Number(max));
                return res
            }

        }
    }

    const getmaxsttephr = (max: any | undefined, steps: any | undefined) => {
        if (max !== undefined && steps !== undefined) {
            if (max === 220) {
                var res = (Number(max) + 10);
                return res
            }
            else {
                return max
            }
        }
    }

    const getWholeAndDecimal = (value: any) => {
        const [whole] = String(value).split('.');
        return Number(whole);
    }

    const getminnumber = (min: any, steps: any) => {
        if (min !== undefined && steps !== undefined) {
            var val = (Number(min) / Number(steps));
            var res = getWholeAndDecimal(val);
            var result = res * steps;
            return result;
        }
        else {
            return 0;
        }
    }

    const getmaxstteps = (max: any | undefined, steps: any | undefined) => {
        if (max !== undefined && steps !== undefined) {
            var Modval = (Number(max) % Number(steps));
            var Divval = (Number(max) / Number(steps));
            var Subval = (Number(steps) - Number(Modval));
            var Mulval = (getWholeAndDecimal(Number(Divval)) * Number(steps));
            var res = (Number(Mulval) + Number(Modval) + Number(Subval));
            return res
        }
    }

    const bglTitle = (times: any) => {
        const title = [];
        times.forEach((element: any) => {
            title.push(<div style={{ width: "59px", height: "25px", marginTop: "-25px", border: "1px Solid black", borderBottom: "0px;", textAlign: "center", background: "#e8eaec", fontFamily: "Lato", fontWeight: "bold", fontSize: "12pt" }}>
                {element}
            </div>);
        });
        for (let i = 0; i <= (numDatapoints - times.length - 1); i++) {
            title.push(<div style={{ width: "59px", height: "25px", marginTop: "-25px", border: "1px Solid black", borderBottom: "0px;", textAlign: "center", background: "#e8eaec", fontFamily: "Lato", fontWeight: "bold", fontSize: "12pt" }}></div>);
        }
        return title;
    }

    const bglHorizontalGridlines = () => {
        const horizontalGridlines = [];
        horizontalGridlines.push(<div className="horizontalGridline" style={{ height: 25, top: 0 }} />);
        return horizontalGridlines;
    }

    const bglVerticalGridlines = (datas: any) => {
        const verticalGridlines = [];
        for (let i = 0; i <= (numDatapoints - 1); i++) {
            let element = datas[i];
            verticalGridlines.push(<div className="verticalGridline" key={i} style={{ width: colWidthInPixels, border: "0.5px Solid black", textAlign: "center", fontFamily: "Lato", fontWeight: "bold", fontSize: "12pt" }}>
                {element >= 0 ? element : ""}
            </div>);
        }
        return verticalGridlines;
    }

    return (
        <div className={classes.observationFormList}>
            {/* <span ><h3 style={{marginLeft:"41px"}}>
            NOTE: </h3></span>
            <span ><h4 style={{marginLeft:"41px"}}>
            Please wait... Do not close the window!!! Generating the PCR Chart PDF. This window will close automatically once the process is complete.</h4></span> */}

            {/* PRINT SCREEN  */}
            <div style={{
                position: "absolute",
                pointerEvents: "none",
                opacity: "0",
            }}>
                <div id="report" ref={htmlRef} className={"printChartSection"} style={{
                    display: "none",
                }}>
                    <div className={"printChartContent"}>
                        <div className={"printHeader"}>
                            <table>
                                <tr>
                                    <td className={"printLeft"}>
                                        <img alt='logo' src="data:image/png;base64,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" />
                                    </td>
                                    <td className={"printCenter"}>
                                        <div>Weight: {uname}kg</div>
                                    </td>
                                    <td className={"printRight"}>
                                        <div className="titleSec">Patient Care Record</div>
                                        <div className="btn">Confidential Personal</div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className={"chartItem"}>
                            <Grid container spacing={0} className={"gridContainer"}>
                                <Grid item className={"leftItem"}>
                                    <div className={"title"}>Respiratory Rate</div>
                                    <div className={"hint"}>Breaths per minute</div>
                                </Grid>
                                <Grid item className={"rightItem"}>
                                    <Charts
                                        config={{
                                            observation: "Respiratory Rate",
                                            units: "Breaths per minute",
                                            low_value: names.filter((x: any) => !isNaN(x)).every((x) => x > Number(ResprateMin)) ? (ResprateMin) : getminnumber(Math.min(...names.filter((num) => !isNaN(num)) as number[]), ResprateSteps),
                                            high_value: names.filter((x: any) => !isNaN(x)).every((x) => x <= Number(ResprateMax)) ? getmaxsttepresp(ResprateMax, ResprateSteps, ResprateMin) : getmaxstteps(Math.max(...names.filter((num) => !isNaN(num)) as number[]), ResprateSteps),
                                            Red_high_value: (Number(getmaxsttepresp(ResprateMax, ResprateSteps, ResprateMin)) > Number(ResprateMax)) ? (Number(getmaxsttepresp(ResprateMax, ResprateSteps, ResprateMin))) - (Number(ResprateMax)) : 0,
                                            step: ResprateSteps,
                                            btf_ranges: {
                                                upper: {
                                                    red_if_above: ResprateRedUpper,
                                                    yellow_if_above: ResprateYellowUpper,
                                                },
                                                lower: {
                                                    yellow_if_below: ResprateYellowLower,
                                                    red_if_below: ResprateRedLower
                                                },
                                            },
                                        }}
                                        data={names}
                                        Observationtime={Observationtime}
                                        numDatapoints={numDatapoints}
                                        colWidth={colWidthInPixels}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div className={"chartItem"}>
                            <Grid container spacing={0} className={"gridContainer"}>
                                <Grid item className={"leftItem"}>
                                    <div className={"title"}>O<sub>2</sub> Saturation</div>
                                    <div className={"hint"}>%</div>
                                </Grid>
                                <Grid item className={"rightItem"}>
                                    <Charts
                                        config={{
                                            observation: " O2 Saturation ",
                                            units: "%",
                                            low_value: Sat.filter((x: any) => !isNaN(x)).every((x) => x > Number(SatMin)) ? (SatMin) : (getminnumber(Math.min(...Sat.filter((num) => !isNaN(num)) as number[]), SatSteps)),
                                            high_value: Sat.filter((x: any) => !isNaN(x)).every((x) => x <= Number(SatMax)) ? SatMax : getmaxstteps(Math.max(...Sat.filter((num) => !isNaN(num)) as number[]), SatSteps),
                                            step: SatSteps,
                                            btf_ranges: {
                                                upper: {
                                                    red_if_above: OSatRedUpper,
                                                    yellow_if_above: OSatYellowUpper,
                                                },
                                                lower: {
                                                    yellow_if_below: OSatYellowLower,
                                                    red_if_below: OSatRedLower,
                                                },
                                            },
                                        }}
                                        data={Sat}
                                        Observationtime={Observationtime}
                                        numDatapoints={numDatapoints}
                                        colWidth={colWidthInPixels}
                                    />
                                </Grid>
                            </Grid>
                        </div> 
                         <div className={"chartItem"}>
                            <Grid container spacing={0} className={"gridContainer"}>
                                <Grid item className={"leftItem"}>
                                    <div className={"title"}>O<sub>2</sub> Flow Rate</div>
                                    <div className={"hint"}>Litres per minute</div>
                                </Grid>
                                <Grid item className={"rightItem"}>
                                    <Charts
                                        config={{
                                            observation: "O2 Flow Rate",
                                            units: "Litres per minute",
                                            low_value: fr.filter((x: any) => !isNaN(x)).every((x) => x > Number(FlowrateMin)) ? FlowrateMin : getminnumber(Math.min(...fr.filter((num) => !isNaN(num)) as number[]), FlowrateSteps),
                                            high_value: fr.filter((x: any) => !isNaN(x)).every((x) => x <= Number(FlowrateMax)) ? (FlowrateMax) : getmaxstteps(Math.max(...fr.filter((num) => !isNaN(num)) as number[]), FlowrateSteps),
                                            step: FlowrateSteps,
                                            btf_ranges: {
                                                upper: {
                                                    red_if_above: OFRedUpper,
                                                    yellow_if_above: OFRYellowUpper,
                                                },
                                                lower: {
                                                    yellow_if_below: OFRYellowLower,
                                                    red_if_below: OFRRedLower
                                                },
                                            },
                                        }}
                                        data={fr}
                                        Observationtime={Observationtime}
                                        numDatapoints={numDatapoints}
                                        colWidth={colWidthInPixels}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        {newborn === 0 && (
                            <div className={"chartItem"}>
                                <Grid container spacing={0} className={"gridContainer"}>
                                    <Grid item className={"leftItem"}>
                                        <div className={"title"}>Systolic BP</div>
                                        <div className={"hint"}>mmHg</div>
                                    </Grid>
                                    <Grid item className={"rightItem"}>
                                        <Charts
                                            config={{
                                                observation: "Blood Pressure",
                                                units: "Systolic in mmHg",
                                                low_value: bpsys.filter((x: any) => !isNaN(x)).every((x) => x > Number(BpMin)) ? ((BpMin)) : (getminnumber(Math.min(...bpsys.filter((num) => !isNaN(num)) as number[]), BpSteps)),
                                                high_value: bpsys.filter((x: any) => !isNaN(x)).every((x) => x <= Number(BpMax)) ? getmaxstepsBp(BpMax, BpSteps) : getmaxstteps(Math.max(...bpsys.filter((num) => !isNaN(num)) as number[]), BpSteps),
                                                Red_high_value: (Number(getmaxstepsBp(BpMax, BpSteps)) > Number(BpMax)) ? (Number(getmaxstepsBp(BpMax, BpSteps))) - (Number(BpMax)) : 0,
                                                step: BpSteps,
                                                btf_ranges: {
                                                    upper: {
                                                        red_if_above: BPRedUpper,
                                                        yellow_if_above: BPYellowUpper,
                                                    },
                                                    lower: {
                                                        yellow_if_below: BPYellowLower,
                                                        red_if_below: BPRedLower
                                                    },
                                                },
                                            }}
                                            data={bpsys}
                                            Observationtime={Observationtime}
                                            numDatapoints={numDatapoints}
                                            colWidth={colWidthInPixels}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                        {diastolic === 1 && newborn === 0 && (
                            <div className={"chartItem"}>
                                <Grid container spacing={0} className={"gridContainer"}>
                                    <Grid item className={"leftItem"}>
                                        <div className={"title"}>Diastolic BP</div>
                                        <div className={"hint"}>mmHg</div>
                                    </Grid>
                                    <Grid item className={"rightItem"}>
                                        <Charts
                                            config={{
                                                observation: "Diastolic BP",
                                                units: "mmHg",
                                                low_value: bpdia.filter((x: any) => !isNaN(x)).every((x) => x > Number(BpdiaMin)) ? (BpdiaMin) : (getminnumber(Math.min(...bpdia.filter((num) => !isNaN(num)) as number[]), BpdiaSteps)),
                                                high_value: bpdia.filter((x: any) => !isNaN(x)).every((x) => x <= Number(BpdiaMax)) ? getmaxsttepsInRange(BpdiaMax, BpdiaSteps) : getmaxstteps(Math.max(...bpdia.filter((num) => !isNaN(num)) as number[]), BpdiaSteps),
                                                Red_high_value: (Number(getmaxsttepsInRange(BpdiaMax, BpdiaSteps)) > Number(BpdiaMax)) ? (Number(getmaxsttepsInRange(BpdiaMax, BpdiaSteps))) - (Number(BpdiaMax)) : 0,
                                                step: BpdiaSteps,
                                                btf_ranges: {
                                                    upper: {
                                                        red_if_above: BPdiaRedUpper,
                                                        yellow_if_above: BPdiaYellowUpper,
                                                    },
                                                    lower: {
                                                        yellow_if_below: BPdiaYellowLower,
                                                        red_if_below: BPdiaRedLower
                                                    },
                                                },
                                            }}
                                            data={bpdia}
                                            Observationtime={Observationtime}
                                            numDatapoints={numDatapoints}
                                            colWidth={colWidthInPixels}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                        <div className={"chartItem"}>
                            <Grid container spacing={0} className={"gridContainer"}>
                                <Grid item className={"leftItem"}>
                                    <div className={"title"}>Heart Rate</div>
                                    <div className={"hint"}>Beats per minute</div>
                                </Grid>
                                <Grid item className={"rightItem"}>
                                    <Charts
                                        config={{
                                            observation: "Heart Rate",
                                            units: "Beats per minute",
                                            low_value: heartrate.filter((x: any) => !isNaN(x)).every((x) => x > Number(HeartrateMin)) ? (HeartrateMin) : (getminnumber(Math.min(...heartrate.filter((num) => !isNaN(num)) as number[]), HeartrateSteps)),
                                            high_value: heartrate.filter((x: any) => !isNaN(x)).every((x) => x <= Number(HeartrateMax)) ? (getmaxsttephr(HeartrateMax, HeartrateSteps)) : getmaxstteps(Math.max(...heartrate.filter((num) => !isNaN(num)) as number[]), HeartrateSteps),
                                            Red_high_value: (Number(getmaxsttephr(HeartrateMax, HeartrateSteps)) > Number(HeartrateMax)) ? (Number(getmaxsttephr(HeartrateMax, HeartrateSteps))) - (Number(HeartrateMax)) : 0,
                                            step: HeartrateSteps,
                                            btf_ranges: {
                                                upper: {
                                                    red_if_above: HRRedUpper,
                                                    yellow_if_above: HRYellowUpper,
                                                },
                                                lower: {
                                                    yellow_if_below: HRYellowLower,
                                                    red_if_below: HRRedLower
                                                },
                                            },
                                        }}
                                        data={heartrate}
                                        Observationtime={Observationtime}
                                        numDatapoints={numDatapoints}
                                        colWidth={colWidthInPixels}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div className={"chartItem"}>
                            <Grid container spacing={0} className={"gridContainer"}>
                                <Grid item className={"leftItem"}>
                                    <div className={"title"}>Temperature</div>
                                    <div className={"hint"}>Degrees Celcius</div>
                                </Grid>
                                <Grid item className={"rightItem"}>
                                    <Charts
                                        config={{
                                            observation: "Temperature",
                                            units: "°C",
                                            low_value: temp.filter((x: any) => !isNaN(x)).every((x) => x > Number(TempMin)) ? TempMin : getminnumber(Math.min(...temp.filter((num) => !isNaN(num)) as number[]), TempSteps),
                                            high_value: temp.filter((x: any) => !isNaN(x)).every((x) => x <= Number(TempMax)) ? (TempMax) : getmaxstteps(Math.max(...temp.filter((num) => !isNaN(num)) as number[]), TempSteps),
                                            step: TempSteps,
                                            btf_ranges: {
                                                upper: {
                                                    red_if_above: TEMPRedUpper,
                                                    yellow_if_above: TEMPYellowUpper,
                                                },
                                                lower: {
                                                    yellow_if_below: TEMPYellowLower,
                                                    red_if_below: TEMPRedLower
                                                },
                                            },
                                        }}
                                        data={temp}
                                        Observationtime={Observationtime}
                                        numDatapoints={numDatapoints}
                                        colWidth={colWidthInPixels}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div className={"chartItem"}>
                            <Grid container spacing={0} className={"gridContainer"}>
                                <Grid item className={"leftItem"}>
                                    <div className={"title"}>Consciousness</div>
                                    <div className={"hint"}>If concerned, wake patient before scoring</div>
                                </Grid>
                                <Grid item className={"rightItem"}>
                                    <Charts
                                        config={{
                                            observation: "Consciousness",
                                            units: "AVPU",
                                            rows: [
                                                {
                                                    label: "A",
                                                    colour: "white",
                                                },
                                                {
                                                    label: "V",
                                                    colour: "yellow",
                                                },
                                                {
                                                    label: "P",
                                                    colour: "red",
                                                },
                                                {
                                                    label: "U",
                                                    colour: "red",
                                                },
                                            ],
                                        }}
                                        data={conc}
                                        Observationtime={Observationtime}
                                        numDatapoints={numDatapoints}
                                        colWidth={colWidthInPixels}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div className={"chartItem printBgl"}>
                            <Grid container spacing={0} className={"gridContainer"}>
                                <Grid item className={"leftItem"}>
                                    <div className={"title"}>Blood Glucose Level</div>
                                    <div className={"hint"}>mmol /L</div>
                                </Grid>
                                <Grid item className={"rightItem"}>
                                    <div className="obsChartPrintArea">
                                        <div className="body">
                                            <div className="Printlabels">
                                                <div className="label" style={{
                                                    height: 25,
                                                    position: "relative",
                                                }}>&nbsp;</div>
                                            </div>
                                            <div className="obsChartPrint" style={{
                                                height: 25,
                                                width: (numDatapoints * colWidthInPixels),
                                            }}>
                                                <div className="titles" style={{ width: (numDatapoints * colWidthInPixels) }}>
                                                    {bglTitle(Observationtime)}
                                                </div>
                                                <div
                                                    className="horizontalGridlines"
                                                    style={{ width: (numDatapoints * colWidthInPixels) }}
                                                >
                                                    {bglHorizontalGridlines()}
                                                </div>
                                                <div className="verticalGridlines">
                                                    {bglVerticalGridlines(bloodsugar)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className={"chartItem"}>
                            <Grid container spacing={0} className={"gridContainer"}>
                                <Grid item className={"leftItem"}>
                                    <div className={"title"}>Pain Score</div>
                                    <div className={"hint"}>None(0) - Worst(10)</div>
                                    <div className={"hint"}>Patient Reported</div>
                                </Grid>
                                <Grid item className={"rightItem"}>
                                    <Charts
                                        config={{
                                            observation: "Pain*",
                                            units: "None (0) - Worst (10)",
                                            low_value: 0,
                                            high_value: 10,
                                            step: 2,
                                            btf_ranges: {
                                                upper: {
                                                    yellow_if_above: newborn === 1 ? 8 : null,
                                                },
                                                lower: {
                                                },
                                            },
                                        }}
                                        data={PainScore}
                                        Observationtime={Observationtime}
                                        numDatapoints={numDatapoints}
                                        colWidth={colWidthInPixels}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
            {/* PRINT SCREEN  */}
        </div>
    );

}


function Charts(props: any) {
    // Setup
    const config = props.config
    const data = props.data
    const rowHeightInPixels = 25
    const colWidthInPixels = props.colWidth
    const chartWidthInPixels = props.numDatapoints * colWidthInPixels
    const Red_high_value = props.config.Red_high_value;
    const Observationtime = props.Observationtime;
    if (config.rows) {

        // Setup for fixed chart (chart rows are defined in configuration)

        var chartHeightInPixels = config.rows.length * rowHeightInPixels

        // Create labels
        var labels = config.rows.map((row: any) => <div
            className="label"
            style={{
                height: rowHeightInPixels,
            }}
        >{row.label}</div>)

        // Crete row backgrounds representing BTF ranges
        var BTFRanges = config.rows.map((row: any, index: any) => {
            return <div
                className={[
                    "rowBackground",
                    row.colour
                ].join(' ')}
                style={{
                    height: rowHeightInPixels,
                    width: chartWidthInPixels,
                    top: index * rowHeightInPixels
                }} />
        })

    } else {

        // Setup for variable chart (chart rows defined by data)

        // Get y range of data
        const datapoints = data.map((datapoint: any) => datapoint.value)
        const highestDatapoint = Math.max(...datapoints)
        const lowestDatapoint = Math.min(...datapoints)

        // Determine bounds of suitable y axis
        var yMax: any = Math.max(config.high_value, Math.ceil(highestDatapoint / config.step) * config.step)
        var yMin: any = Math.min(config.low_value, Math.floor(lowestDatapoint / config.step) * config.step)
        var chartRange = yMax - yMin
        var chartHeightInPixels = rowHeightInPixels * chartRange / config.step

        // Create labels
        var labels: any = []
        for (var i = yMax; i >= yMin; i -= config.step) {
            labels.push(<div
                className="label"
                style={{
                    height: rowHeightInPixels,
                    position: "relative",
                    top: 0 - rowHeightInPixels / 2,
                    fontFamily: "Lato", fontWeight: "bold", fontSize: "12pt"
                }}
            >{i}</div>);
        }

        // Crete BTF range backgrounds
        var BTFRanges: any = [];
        ["upper", "lower"].forEach(direction => {
            ["blue", "yellow", "red"].forEach(color => {
                const threshold = config.btf_ranges[direction][color + (direction === "upper" ? "_if_above" : "_if_below")]
                if (threshold) {
                    BTFRanges.push(
                        <BTFRange
                            height={direction === "upper" ? chartHeightInPixels - getYPos(threshold) : getYPos(threshold)}
                            width={chartWidthInPixels}
                            direction={direction === "upper" ? "up" : "down"}
                            color={color}
                        />
                    )
                    if (direction === "upper" && Red_high_value > 0) {
                        BTFRanges.push(
                            <BTFRange
                                height={Red_high_value + "px"}
                                width={chartWidthInPixels}
                                direction={direction === "upper" ? "up" : "down"}
                                color="white"
                            />
                        );
                    }
                }
            })
        })

    }

    // Create horizontal gridlines
    const horizontalGridlines = []
    for (let i = 0; i < chartHeightInPixels; i += rowHeightInPixels) {
        horizontalGridlines.push(<div className="horizontalGridline" key={i} style={{ height: rowHeightInPixels, top: i }} />);
    }

    // Create vertical gridlines
    const verticalGridlines = []
    for (let i = 0; i <= props.numDatapoints - 1; i++) {
        verticalGridlines.push(<div className="verticalGridline" key={i} style={{ width: colWidthInPixels, border: "0.5px Solid black" }} />);
    }

    // Create dots
    const dots = data.map((datapoint: any) => {
        return (
            <div
                className="dot"
                style={{
                    left: colWidthInPixels / 2 + datapoint.col * colWidthInPixels,
                    bottom: getYPos(datapoint.value)
                }}
                key={datapoint.col}
            />
        )
    })

    // Create connecting lines
    const lines = data.map((datapoint: any, index: any) => {
        const nextDatapoint = data[index + 1]
        if (!nextDatapoint) { return "" }
        return <line
            id={"line_" + datapoint.col}
            data-name={"line_" + datapoint.col}
            x1={colWidthInPixels / 2 + datapoint.col * colWidthInPixels}
            y1={chartHeightInPixels - getYPos(datapoint.value)}
            x2={colWidthInPixels / 2 + nextDatapoint.col * colWidthInPixels}
            y2={chartHeightInPixels - getYPos(nextDatapoint.value)}
            fill="none"
            stroke="#00142e"
            stroke-width="3"
        />
    })

    // Function to return the Y position (in pixels) for a given datapoint.
    // Logic varies depending on whether chart is fixed or variable
    function getYPos(datapoint: any) {

        // Logic for variable chart
        if (!config.rows) {
            return (datapoint - yMin) / chartRange * chartHeightInPixels
        }

        // Logic for fixed chart
        var YPos = 0
        config.rows.forEach((row: any, index: any) => {
            if (row.label === datapoint) {
                index = 3 - index;
                YPos = index * rowHeightInPixels + rowHeightInPixels / 2
            }
        })
        return YPos

    }
    // Create vertical gridlines
    const title = []
    Observationtime.forEach((element: any) => {
        title.push(<div style={{ width: "59px", height: "25px", marginTop: "-25px", border: "1px Solid black", borderBottom: "0px;", textAlign: "center", background: "#e8eaec", fontFamily: "Lato", fontWeight: "bold", fontSize: "12pt" }}>
            {element}
        </div>);
    });
    for (let i = 0; i <= props.numDatapoints - Observationtime.length - 1; i++) {
        title.push(<div style={{ width: "59px", height: "25px", marginTop: "-25px", border: "1px Solid black", borderBottom: "0px;", textAlign: "center", background: "#e8eaec", fontFamily: "Lato", fontWeight: "bold", fontSize: "12pt" }}>

        </div>);
    }
    // Render
    return (
        <div className="obsChartPrintArea">
            <div className="body">
                <div className="Printlabels">{labels}</div>

                <div className="obsChartPrint" style={{
                    height: rowHeightInPixels * ((yMax - yMin) / config.step),
                    width: chartWidthInPixels
                }}>
                    <div className="titles" style={{ width: chartWidthInPixels }} >{title}</div>
                    {BTFRanges}
                    <div
                        className="horizontalGridlines" style={{ width: chartWidthInPixels }}  >
                        {horizontalGridlines}
                    </div>
                    <div className="verticalGridlines">{verticalGridlines}</div>

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none"
                        viewBox={`0 0 ${chartWidthInPixels} ${chartHeightInPixels}`}
                        height={chartHeightInPixels}
                        width={chartWidthInPixels}
                        className="line"
                    >
                        {lines}
                    </svg>
                    {dots}
                </div>
            </div>
        </div>
    );
}

function BTFRange(props: any) {
    return (
        <div
            className={["btfRange", props.color, props.direction].join(" ")}
            style={{
                height: props.height ? props.height : 0,
                width: props.width,
            }}
        />
    );
}

export default React.memo(withRouter(PCRObservationChartPDF));